import { createAction, props } from '@ngrx/store';
import { Task } from 'domain-entities';
import { EntityChanges } from '@craftnote/shared-utils';

export const loadCompanyTasks = createAction('[Tasks] Load Company Tasks');
export const setCompanyTasks = createAction(
	'[Tasks] Set Company Tasks',
	props<{ changes: EntityChanges<Task> }>(),
);
